export const BELT_ORDER = [
  'White',
  'White-Yellow Stripe',
  'Yellow',
  'Yellow-Green Stripe',
  'Green',
  'Green-Blue Stripe',
  'Blue',
  'Blue-Red Stripe',
  'Red',
  'Red-Black Stripe',
  'Black - 1st Dan',
  'Black - 2nd Dan',
  'Black - 3rd Dan',
];

export const MIN_MONTHS_PER_BELT = 3;

export function getNextBelt(currentBelt) {
  const idx = BELT_ORDER.indexOf(currentBelt);
  if (idx === -1 || idx === BELT_ORDER.length - 1) return null;
  return BELT_ORDER[idx + 1];
}
